import Masonry from "masonry-layout";

const successStories = {
  init() {
    successStories.create();
  },
  create() {
    if ($("[data-success-stories]").length) {
      var grid = document.querySelector(".masonry-success-stories-grid");
      var msnry = new Masonry(grid, {
        columnWidth: ".panel.panel-success-stories .card [data-thumb]",
        horizontalOrder: true,
        percentPosition: true,
        isOriginLeft: false,
      });

      $(document).on("click", "[data-thumb]", function (e) {
        e.preventDefault();
        const self = $(this);
        const idx = self.data("index");
        const eleP = self.closest("[data-success-stories]");
        const currentTotalThumbs = self
          .closest("[data-success-stories]")
          .find("[data-thumb]").length;
        const total = eleP.find("[data-story]").length;

        const eleCurrent = eleP.find(`[data-story].active`);
        const eleCurrentPortrait = eleP.find(`[data-portrait].active`);
        const eleTarget = eleP.find(`[data-story][data-index="${idx}"]`);
        const eleTargetPortrait = eleP.find(`[data-portrait][data-index="${idx}"]`);

        if (eleTarget.length) {
          if (eleCurrent.length) {
            TweenMax.staggerTo(
              eleCurrent.find("[data-text]"),
              0.75,
              { opacity: 0 },
              0.15
            );
            TweenMax.to(eleCurrentPortrait, 0.5, { opacity: 0 });
          }

          eleP.find("[data-story]").removeClass("active");
          eleTarget.addClass("active");
          eleP.find("[data-portrait]").removeClass("active");
          eleTargetPortrait.addClass("active");

          TweenMax.set(eleTarget.find("[data-text]"), {
            opacity: 0,
          });
          TweenMax.staggerTo(
            eleTarget.find("[data-text]"),
            0.75,
            { opacity: 1 },
            0.15
          );

          TweenMax.to(eleTargetPortrait, 0.75, { opacity: 1 });

          msnry.remove(self);

          if (total - currentTotalThumbs === 1) {
            // Append
            var fragment = document.createDocumentFragment();
            var elem = document.createElement("a");
            elem.classList.add("item");
            elem.classList.add("item-appended");
            elem.setAttribute(
              "data-thumb",
              ''
            );
            elem.setAttribute(
              "data-index",
              eleCurrent.data("index")
            );
            const img = document.createElement("img");
            img.src = eleCurrent.data("thumb-image");
            img.classList.add('object-cover');
            elem.appendChild(img);

            fragment.appendChild(elem);
            grid.appendChild(fragment);
            msnry.appended([elem]);
            // End of Append
          }
        }

        msnry.layout();
      });

      $("[data-thumb]").eq(0).trigger("click");

      $("[data-arrow]").on("click", function (e) {
        e.preventDefault();
        const self = $(this);
        const direction = self.data("arrow");
        const total = self
          .closest("[data-success-stories]")
          .find("[data-story]").length;
        const idxCurrentMember = parseInt(
          self
            .closest("[data-success-stories]")
            .find(`[data-story].active`)
            .data("index")
        );
        let targetMember;

        if (direction === "next") {
          targetMember =
            idxCurrentMember + 1 > total - 1 ? 0 : idxCurrentMember + 1;
        } else {
          targetMember =
            idxCurrentMember - 1 < 0 ? total - 1 : idxCurrentMember - 1;
        }

        self
          .closest("[data-success-stories]")
          .find(`[data-thumb][data-index="${targetMember}"]`)
          .trigger("click");
      });
    }
  },
};

$(function () {
  successStories.init();
});
